import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scheduled-maintenance',
  templateUrl: './scheduled-maintenance.component.html',
  styleUrls: ['./scheduled-maintenance.component.css']
})
export class ScheduledMaintenanceComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  public goToHelpCenter(): void {
    alert("Navigating to Help Center");
  }

  public goToSystemStatus(): void {
    alert("Navigating to System Status");
  }

  public goToReleaseNotes(): void {
    alert("Navigating to Release Notes");
  }

}
